let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lUQNB")).then(() => parcelRequire('jsr3R'));